import React, { PropTypes } from 'react';

import { userProfileShape } from '../../proptypes';

import UserMenuLoggedIn from './components/UserMenuLoggedIn';
import UserMenuLoggedOut from './components/UserMenuLoggedOut';

/**
 * User menu presentational component.
 * Renders with logged in or logged out user menu.
 */
const UserMenu = ({ className, onLinkClick, profile, ...props }) => {
  if (profile) {
    return <UserMenuLoggedIn className={className} profile={profile} {...props} />;
  }
  return <UserMenuLoggedOut className={className} onLinkClick={onLinkClick} {...props} />;
};

UserMenu.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean describing user autenticated state.
   */
  loggedIn: PropTypes.bool,
  /**
   * Function called on link click.
   */
  onLinkClick: PropTypes.func,
  /**
   * Normalized user profile object, when user is logged in
   */
  profile: userProfileShape,
};

UserMenu.defaultProps = {
  className: '',
  loggedIn: false,
  onLinkClick: () => {},
  profile: null,
};

export default UserMenu;



// WEBPACK FOOTER //
// ./app/src/components/UserMenu/index.jsx